import errorReporter from '@app/errorReporter';

angular.module('bb.assets').component('bbAddVideoModal', {
  controller: AddVideoModalController,
  controllerAs: 'vm',
  template: require('./add_video_modal.html'),
});

AddVideoModalController.$inject = ['ModalService', 'AssetsService'];

function AddVideoModalController(ModalService, AssetsService) {
  const vm = this;

  vm.addVideoModal = ModalService.addVideoModal;

  vm.validate = () => {
    if (!vm.video?.link) {
      vm.result = { error: 'Please provide a link.' };
      return;
    }
    vm.validating = true;
    AssetsService.getVideoMeta(vm.video.link)
      .then(result => {
        vm.result = result;
        vm.validating = false;

        if (result.title) {
          vm.isValid = true;
        } else {
          vm.result = { error: 'Please provide a valid non-private link.' };
        }
      })
      .catch(err => {
        vm.validating = false;
        vm.result = { error: err.data.message };
        errorReporter.error(err);
      });
  };

  vm.invalidate = () => {
    vm.isValid = false;
    vm.result = false;
  };

  vm.saveVideo = () => {
    vm.saving = true;
    const videoLinkFile = [
      {
        filename: vm.result.title,
        mimetype: 'application/x-shockwave-flash',
        url: vm.video.link,
        thumbnail: vm.result.thumbnail,
        embedUrl: vm.result.embedUrl,
      },
    ];

    AssetsService.assetFileUpload(
      videoLinkFile,
      vm.addVideoModal.selectedFolderId,
    )
      .then(() => {
        vm.result = null;
        vm.video.link = '';
        vm.saving = false;
        ModalService.closeAddVideoModal(true);
      })
      .catch(errorReporter.error);
  };

  vm.closeModal = () => {
    vm.result = null;
    ModalService.closeAddVideoModal();
  };
}
